import { DynamicText as DynamicTextType } from '../../../../../types/Survey/Element'
import { DynamicText as DynamicTextAnswerType } from '../../../../../types/Survey/Answer/Element'
import { Props } from './types'
import Core from './Core'
import Input from '../../../../UI/Input/Input'
import { getDynamicTextAnswer } from '../../../../hooks/useSurveyAnswer/transformElementsToAnswers'
import { useEffect } from 'react'

const DynamicText: React.FC<Props<DynamicTextType, DynamicTextAnswerType>> = ({ element, answerElement, updateElement }) => {
  const set = (uuid: string) => (value: string) => {
    // update answer
    const updatedAnswer = { ...answerElement }
    updatedAnswer.textAnswers = answerElement.textAnswers.map((tA) => (tA.uuid === uuid ? { ...tA, value } : tA))

    // decide if we should add another answer field
    const lastAnswer = updatedAnswer.textAnswers[updatedAnswer.textAnswers.length - 1]
    if (lastAnswer.value.length > 0 && (element.maxAnswerCount === 0 || element.maxAnswerCount > updatedAnswer.textAnswers.length)) {
      updatedAnswer.textAnswers.push(getDynamicTextAnswer())
    }
    updateElement(updatedAnswer)
  }

  useEffect(() => {
    if (answerElement.textAnswers.length === 0) {
      updateElement({ ...answerElement, textAnswers: [getDynamicTextAnswer()] })
    }
  }, [element, answerElement, updateElement])

  return (
    <div>
      <Core element={element} answerElement={answerElement} />
      <div className="flex flex-col gap-3 mt-3">
        {answerElement.textAnswers.map((tA, i) => (
          <div className="flex flex-row items-center gap-3" key={tA.uuid}>
            <div className="w-6 aspect-square shrink-0 bg-cyan rounded-full flex items-center justify-center text-white text-sm">{i + 1}</div>
            <Input key={tA.uuid} value={tA.value} onChange={set(tA.uuid)} maxLength={100} className="xl:w-[40vw]" />
          </div>
        ))}
      </div>
    </div>
  )
}

export default DynamicText
